import api from '@/services/api.js';

export default {
    // upload(formData){
    //     return api.post('/video-libraries', formData);   
    // },
    // update(fileId, formData){
    //     return api.put('/video-libraries/video/' + fileId, formData);   
    // },
    getOne(templateId){
        return api.get('/email-templates/' + templateId);
    },
    getOneByIdentifier(templateIdentifier){
        return api.get('/email-templates/identifier/' + templateIdentifier);
    },
    getAll(){
        return api.get('/email-templates');
    },
    // delete(fileId){
    //     return api.delete('/video-libraries/video/' + fileId);
    // }
}